import type { User } from './common';

/**
 * Whether the user has reached the actual application rather than one of AuthGuard's interstitials
 * (unverified email, pending approval, declined).
 *
 * AuthGuard decides *which* of those screens to show and needs the tri-state `is_approved` for it;
 * this answers only whether there is access at all. It exists for the UI mounted outside the guard —
 * the assistant dialog in App.tsx and the launcher on the public /verification route — which would
 * otherwise render over the "Account pending" screen against endpoints that answer 403.
 */
export const hasAppAccess = (user: User | null): boolean => Boolean(user?.email_verified && user?.is_approved);
